export default __webpack_public_path__ + "static/swvl-78327501c00351face25d87e766bb134.svg";